// extracted by mini-css-extract-plugin
export default {"Scrollbar":"Scrollbar_Scrollbar__YnfO+","overflow-y":"Scrollbar_overflow-y__2i3QY","overflow-x":"Scrollbar_overflow-x__2KOlm"};